import { render, staticRenderFns } from "./Topic-glasgow.vue?vue&type=template&id=9dd78156&scoped=true"
import script from "./Topic-glasgow.vue?vue&type=script&lang=js"
export * from "./Topic-glasgow.vue?vue&type=script&lang=js"
import style0 from "./Topic-glasgow.vue?vue&type=style&index=0&id=9dd78156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd78156",
  null
  
)

export default component.exports